import { OBtcWalletId, OEvmWalletId } from 'modules/api';
import { default as BinanceIcon } from 'modules/common/assets/binance.svg?react';
import { FC, useMemo } from 'react';
import { default as BitgetIcon } from './assets/bitget.svg?react';
import { default as MetaMaskIcon } from './assets/metamask.svg?react';
import { default as OkxWalletIcon } from './assets/okx.svg?react';
import { default as TomoIcon } from './assets/tomo.svg?react';
import { default as WalletConnectIcon } from './assets/wallet-connect.svg?react';
import { default as DefaultWalletIcon } from './assets/wallet-icon.svg?react';
import { default as XverseIcon } from './assets/xverse.svg?react';
import { default as CoinbaseIcon } from './assets/coinbase.svg?react';
import { default as BybitIcon } from './assets/bybit.svg?react';
import { default as CloverIcon } from './assets/clover.svg?react';
import { default as Coin98Icon } from './assets/coin98.svg?react';
import { default as TrustIcon } from './assets/trust.svg?react';

import { useWalletIconStyles } from './useWalletIconStyles';

interface IWalletIconProps {
  wallet?: string;
  title?: string;
  className?: string;
  walletName?: string;
}

export function WalletIcon({
  wallet,
  title,
  className,
}: IWalletIconProps): JSX.Element {
  const { classes, cx } = useWalletIconStyles();
  const Icon = useMemo(() => getWalletIcon(wallet), [wallet]);

  return <Icon className={cx(classes.root, className)} title={title} />;
}

export function getWalletIcon(
  wallet?: string,
): FC<{ className?: string; title?: string }> {
  switch (wallet) {
    case OEvmWalletId.injected:
      return MetaMaskIcon;

    case OEvmWalletId.walletconnect:
      return WalletConnectIcon;

    case OEvmWalletId.coinbase:
      return CoinbaseIcon;

    case OEvmWalletId.binanceWallet:
      return BinanceIcon;

    case OBtcWalletId.OKX:
    case OEvmWalletId.okxwallet:
      return OkxWalletIcon;

    case OBtcWalletId.Xverse:
      return XverseIcon;

    case OBtcWalletId.Tomo:
    case OEvmWalletId.tomo:
      return TomoIcon;

    case OBtcWalletId.Bitget:
    case OEvmWalletId.bitget:
      return BitgetIcon;

    case OEvmWalletId.bybit:
      return BybitIcon;

    case OEvmWalletId.coin98:
      return Coin98Icon;

    case OEvmWalletId.clover:
      return CloverIcon;

    case OEvmWalletId.trust:
      return TrustIcon;

    default:
      return DefaultWalletIcon;
  }
}
